import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle, Globe, Award, ShieldCheck, Star } from 'lucide-react';
export function Hero() {
  return <section className="bg-navy text-white pt-6 pb-10 px-4 sm:px-6 lg:px-8 overflow-hidden relative" data-id="element-51">
      {/* Subtle radial glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange/5 rounded-full blur-3xl pointer-events-none" data-id="element-52"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-53">
        {/* Discount badge */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 bg-orange/20 border border-orange/30 px-5 py-2 rounded-full text-sm font-bold mb-8 text-orange" data-id="element-54">
          <Star size={14} className="fill-orange text-orange" data-id="element-55" />
          <span data-id="element-56">¡60% de descuento sobre el precio de venta al público!</span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mb-8 leading-tight text-center" data-id="element-57">
          <span className="block text-lg md:text-xl text-gray-400 font-medium mb-2" data-id="element-58">
            ¡Dejá de sufrir en silencio!
          </span>
          <span className="block text-2xl md:text-4xl font-heading font-extrabold uppercase tracking-tight" data-id="element-59">
            ¡Duplicá tu claridad emocional
          </span>
          <span className="block text-orange text-2xl md:text-4xl font-heading font-extrabold uppercase tracking-tight" data-id="element-60">
            desde la primera noche!
          </span>
        </motion.h1>

        {/* Product Mockup with background glow and click animation */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="mb-8 relative cursor-pointer max-w-sm mx-auto" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.97,
        rotate: -1
      }} data-id="element-61">
          {/* Background glow behind mockup */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-62">
            <div className="w-56 h-56 md:w-72 md:h-72 bg-orange/15 rounded-full blur-3xl" data-id="element-63"></div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-64">
            <div className="w-40 h-40 md:w-56 md:h-56 bg-orange/10 rounded-full blur-2xl" data-id="element-65"></div>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/m3AyNUaqiN7voEiKYCgC6H/Untitled_design_(2).png" alt="Kit de Psicología Pro" className="w-full mx-auto drop-shadow-2xl mix-blend-screen relative z-10" data-id="element-66" />
        </motion.div>

        {/* Description */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.35
      }} className="text-base md:text-xl text-gray-300 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-67">
          <span className="text-orange font-heading font-bold" data-id="element-68">
            Kit de Psicología Pro
          </span>{' '}
          te da las herramientas terapéuticas para calmar tu mente de principio
          a fin. El sistema definitivo para cualquier persona. Descargalo,
          aplicalo y transformá tu vida.
        </motion.p>

        {/* Social proof badges */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.45
      }} className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mb-8 text-sm text-gray-400" data-id="element-69">
          <div className="flex items-center gap-1.5" data-id="element-70">
            <CheckCircle size={16} className="text-orange" data-id="element-71" />
            <span data-id="element-72">Miles de kits vendidos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-73">
            <Globe size={16} className="text-orange" data-id="element-74" />
            <span data-id="element-75">Usado en +15 países</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-76">
            <Award size={16} className="text-orange" data-id="element-77" />
            <span data-id="element-78">Recomendado por profesionales</span>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.55
      }} className="flex flex-col items-center gap-3" data-id="element-79">
          <Button className="shadow-[0_0_30px_rgba(232,131,58,0.4)] text-lg md:text-xl px-10" data-id="element-80">
            Obtener mi Kit de Psicología Pro →
          </Button>
          <div className="flex items-center gap-1.5 text-gray-500 text-xs" data-id="element-81">
            <ShieldCheck size={14} data-id="element-82" />
            <span data-id="element-83">Garantía de devolución sin preguntas</span>
          </div>
        </motion.div>
      </div>
    </section>;
}